import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { AuthFacade } from '../+state/auth.facade';
import { map, filter, switchMap, take, tap } from 'rxjs/operators';

@Injectable()
export class AuthGuard {
  constructor(public authFacade: AuthFacade, private router: Router) {}

  authLoaded$ = this.authFacade.isUserAuthenticated$.pipe(
    tap((isAuth) => {
      if (!isAuth) {
        this.router.navigate([`/login`], {});
      }
    }),
    take(1),
  );

  canActivate(route: ActivatedRouteSnapshot) {
    return this.authLoaded$.pipe(
      switchMap(() =>
        this.authFacade.isUserAuthenticated$.pipe(
          map((isAuthenticated) => {
            if (!isAuthenticated) {
              this.router.navigate([`/login`], {});
              return false;
            }
            return true;
          }),
        ),
      ),
    );
  }
}
